/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/label-has-associated-control */
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Stack } from '@mui/material';
import copy from 'copy-to-clipboard';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../components/LoadingAnimation';
import Userbanner from '../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { getAsync, putAsync, reactURL } from '../../components/helper/axiosHelper';
import { menucontrol } from '../../features/togglebuttonSlice';
import { getStorage } from '../../libs/getStorage';
import { PageHitCountApi } from '../../shared/Helper';
import UserDashboardCard from './UserDashboardCard';
import UserLogs from './UserLogs';
import UserPersonalnfo from './UserPersonalnfo';
import CloseIcon from '@mui/icons-material/Close';

const UserPortalHomePage = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [name, setName] = useState(getStorage('name'));
  const [role, setRole] = useState(getStorage('role'));
  const [email, setEmail] = useState(getStorage('email'));
  const [epUserID, setEpUserID] = useState(null);
  const [isload, setIsload] = useState(false);
  const [selectedButton, setSelectedButton] = useState('Edit Profile');
  const [tab, setTab] = useState(1);
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [isProfilePicUpdated, setIsProfilePicUpdated] = useState(false);
  const [isUserDataUpdated, setIsUserDataUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [isUpdateImg, setIsUpdateImg] = useState(false);
  const [profilePicBody, setProfilePicBody] = useState({
    file: null,
    link: '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isSecurityEditing, setIsSecurityEditing] = useState(false);
  const [isPasswordEditing, setIsPasswordEditing] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    userName: '',
    nationalCode: '',
    dateOfBirth: '',
    countryID: '',
    educationLevel: '',
    city: '',
    doc: '',
  });
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [formError, setFormError] = useState({});
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showhide, setShowhide] = useState(0);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [selectedEmiratesID, setSelectedEmiratesID] = useState(0);

  const location = useLocation();
  const { id } = location.state || {};
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem('token');

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    if (isUpdateImg) {
      getUserData();
      setIsUpdateImg(false);
    }
  }, [isUpdateImg]);

  useEffect(() => {
    if (role === 'Admin') {
      navigate('/Admin');
    } else {
      dispatch(menucontrol(false));
      localStorage.setItem('isHome', false);
      setName(getStorage('name'));
      setRole(getStorage('role'));
      setEmail(getStorage('email'));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('isHome', false);

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (epUserID !== null) {
      getUserData();
      getCountries();
      getEmirates();
      PageHitCountApi(location.pathname, epUserID);
    }
  }, [epUserID]);

  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  //   setPreviewImage(null);
  // };
const closeModal = () => {
  setIsModalOpen(false);
  setPreviewImage(null);
  setIsProfilePicUpdated(false);
  if (fileInputRef.current) {
    fileInputRef.current.value = ''; // Clear the file input
  }
};
  const handleEditClick = (tabId) => {
    if (tabId == 1) {
      setIsEditing(true);
    }
    if (tabId == 2) {
      setIsSecurityEditing(true);
    }
    if (tabId == 4) {
      setIsPasswordEditing(true);
    }
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    setIsEditing(false);
  };

  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   console.log(name, value, "namename")
  //   setIsUserDataUpdated(true);
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));

  //   if (name === "countryID") {
  //     if (value == 208) {
  //       console.log("thid if ")
  //       setShowhide(value);
  //       console.log(value, "thid")
  //     } else {
  //       setFormData((prev) => ({
  //         ...prev,
  //         emiratesID: 0,
  //       }));
  //       setShowhide(0);
  //       console.log("thid else ")
  //     }

  //   }

  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsUserDataUpdated(true);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === 'countryID') {
      if (value == 208) {
        setShowhide(value);
      } else {
        setFormData((prev) => ({
          ...prev,
          emiratesID: 0,
        }));
        setShowhide(0);
      }
    }
  };

  const handleOnSelectEmirate = (selectedEmirates) => {
    const emirates = selectedEmirates.target.value;
    if (emirates == null || emirates == undefined || emirates == 0) {
      setSelectedEmiratesID(0);
    }
    setSelectedEmiratesID(emirates);
  };

  const updateProfilePic = async () => {
    await putAsync(
      'EP_UserAuthentication/UpdateEPUserImage',
      profilePicBody,
      {
        id: epUserID,
      },
      'multipart/form-data',
    )
      .then((response) => {
        if (response?.statusCode === 200) {
          // toast.success(`${t('Profile Image Updated SuccessUpdated')}`);
          setIsUpdateImg(true);
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        setProfilePicBody((prev) => ({
          ...prev,
          link: baseURL.split(',')[1],
        }));
        // setLink(baseURL.split(',')[1]);
        resolve(baseURL);
      };
    });
  };

  // const handleProfileChange = (e) => {
  //   setPreviewImage('');
  //   const selectedFile = e.target.files[0];
  //   const imgSize = selectedFile.size;
  //   const extension = selectedFile?.name.split('.')[1];
  //   if ((extension == 'jpg' || extension == 'png' || extension == 'jpeg') && imgSize <= 2097152) {
  //     setPreviewImage(URL.createObjectURL(e.target.files[0]));
  //     setIsProfilePicUpdated(true);
  //     getBase64(selectedFile)
  //       .then((result) => {
  //         selectedFile['base64'] = result;
  //         setProfilePicBody({
  //           file: selectedFile,
  //           link: result,
  //         });
  //         toast.success(t('File uploaded successfully.'));
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } else {
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = '';
  //       setPreviewImage('');
  //       setFormData({ doc: null });
  //       setProfilePicBody({
  //         file: '',
  //         link: '',
  //       });
  //     }
  //     toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
  //   }
  // };
const handleProfileChange = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  const imgSize = selectedFile.size;
  const extension = selectedFile?.name.split('.')[1].toLowerCase();
  
  if ((extension === 'jpg' || extension === 'png' || extension === 'jpeg') && imgSize <= 2097152) {
    setPreviewImage(URL.createObjectURL(selectedFile));
    setIsProfilePicUpdated(true);
    
    getBase64(selectedFile)
      .then((result) => {
        setProfilePicBody({
          file: selectedFile,
          link: result.split(',')[1],
        });
        toast.success(t('File uploaded successfully.'));
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setPreviewImage(null);
    toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
  }
};
  const updateUser = async () => {
    setLoading(true);
    setIsEditing(false);

    if (formData.countryID == 208 && formData.emiratesID == 0) {
      toast.error(t('Please select the Emirate'));
      setLoading(false); // Stop loading if validation fails
    } else {
      const userWithUserName = {
        countryID: formData.countryID,
        fullName: formData.fullName,
        userName: formData.userName,
        emiratesID: formData.emiratesID,
      };

      const userWithoutUserName = {
        countryID: formData.countryID,
        fullName: formData.fullName,
        emiratesID: formData.emiratesID,
      };

      const bodyOutput = formData.userName === apiData.userName ? userWithoutUserName : userWithUserName;

      await putAsync('EP_UserAuthentication/UpdateEPUser', bodyOutput, { id: epUserID }, 'multipart/form-data')
        .then((response) => {
          setLoading(false);

          if (response?.statusCode === 200) {
            toast.success(`${t('Updated Successfully')}`);

            setIsUpdateImg(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          if (err.response.status === 422) {
            getUserData();
            toast.error('This user name already exists, try another ');
          } else {
            toast.error(t('Something went wrong, Please try again!'));
          }
        });
    }
  };

  // const handleSave = () => {
  //   setIsProfilePicUpdated(false);
  //   setIsModalOpen(false);

  //   if (isUserDataUpdated) {
  //     updateUser();
  //   }

  //   if (isProfilePicUpdated) {
  //     updateProfilePic();
  //   }
  // };
  const handleSave = () => {
    setIsProfilePicUpdated(false);
    setIsModalOpen(false);

    if (isUserDataUpdated) {
      updateUser();
    }

    if (isProfilePicUpdated) {
      updateProfilePic();
    } else {
      setPreviewImage(null); // Reset preview if image wasn't saved
    }
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList')
      .then((response) => {
        const result = response?.data;
        setCountryAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getUserData = async () => {
    setIsload(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        setIsload(false);
        setApiData(result);
        setFormData(result);
        setShowhide(result?.countryID);
        if (result?.countryID == 208) {
        }

        // setProfilePic(formData.doc)
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // selected buttons color
  const handleButtonClick = (buttonName, id) => {
    setSelectedButton(buttonName);
    setTab(id);
  };

  // password change function
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validatePassword = () => {
    const errors = {};
    const { newPassword, confirmPassword } = passwordData;

    if (newPassword.length < 8) {
      errors.newPassword = 'New Password Must be 8 or more characters long';
    } else if (!/[0-9]/.test(newPassword)) {
      errors.newPassword = 'Must contain at least one number';
    } else if (!/[a-z]/.test(newPassword)) {
      errors.newPassword = 'Must contain at least one lowercase letter';
    } else if (!/[A-Z]/.test(newPassword)) {
      errors.newPassword = 'Must contain at least one uppercase letter';
    }

    if (newPassword !== confirmPassword) {
      errors.confirmPassword = 'Confirm Passwords must match';
    }

    setFormError(errors);
    return errors;
  };

  const changePassword = (e) => {
    e.preventDefault();
    setIsPasswordEditing(false);
    // Check if all fields are filled
    const { oldPassword, newPassword, confirmPassword } = passwordData;
    if (!oldPassword || !newPassword || !confirmPassword) {
      toast.error(t('Please fill all  fields'));
      return;
    }

    const errors = validatePassword();

    if (Object.keys(errors).length > 0) {
      for (const key in errors) {
        toast.error(`${t(errors[key])}`);
        return;
      }
    } else {
      const bodyUpdate = {
        mobile: apiData.mobile,
        email: apiData.email,
        password: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      };

      putAsync('EP_UserAuthentication/EP_User_PasswordChange', bodyUpdate)
        .then((response) => {
          const result = response?.statusCode;
          if (result === 200) {
            toast.success(`${t('Successfully changed password')}`);

            setPasswordData({
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',
            });
          } else {
            toast.error(`${t('Please enter correct current password')}`);
          }
        })
        .catch((error) => {
          toast.error(`${t('Please enter correct current password')}`);
        });
    }
  };

  // Copy link Function
  const handleCopy = async () => {
    try {
      await getAsync(`EP_UserAuthentication/EPUserByID/`, { id: epUserID }, axiosConfig).then((response) => {
        const result = response?.data[0];
        if (
          result?.epUserID === undefined ||
          result?.epUserID === null ||
          result?.epUserID === 0 ||
          result?.profileLink === undefined ||
          result?.profileLink === null ||
          result?.profileLink === ''
        ) {
          toast.warning(`${t('Failed to copy refferal link data not found')}`);
        } else {
          // const epUserProfile = `${reactURL}/PublicProfile/` + result?.profileLink + '/' + result?.epUserID +'/'+ 1;
          const epUserProfile = `${reactURL}/PublicProfile/` + result?.profileLink + '/' + 1;

          copy(epUserProfile);
          toast.success(`${t('Link copy Successfully')}`);
        }
      });
    } catch (error) {
      console.error('Error fetching record:', error);
    }
  };

  const buttonArray = [
    {
      name: 'Edit Profile',
      id: 1,
    },
    {
      name: 'Security',
      id: 2,
    },
    {
      name: 'Change Password',
      id: 4,
    },
    {
      name: 'Login History',
      id: 5,
    },
  ];

  const handleImageUpload = () => {
    document.getElementById('filee').click();
    // setIsUpdateImg(false)
  };

  // mouse enter and  leave function

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      {isload ? (
        <LoadingAnimation
          imageStyling={''}
          styling={'flex items-center py-10 lg:pt-32  align-middle justify-center space-x-2'}
        />
      ) : (
        <>
          <div className="pt-12  ">
            <Userbanner />
            {apiData?.fullName && (
              <div className="container-fluid sm:px-5">
                {/* heading  */}
                <div className=" flex justify-center py-3 ">
                  <h2 className="text-3xl text-customgreen text-center  w-full  font-bold">{t('Dashboard')}</h2>
                </div>
                <div className="w-full mx-auto bg-white p-2 md:p-6 rounded-lg border-2 border-gray-50 flex flex-col md:flex-row">
                  <div className="flex w-full lg:px-10 pb-3 md:pb-16 flex-col">
                    {loading ? (
                      <LoadingAnimation />
                    ) : (
                      <>
                        {/* Profile Section */}
                        {/* <div className=" align-middle justify-center sm:ps-20 sm:pt-10"> */}
                        <div className=" align-middle justify-center sm:ps-4 sm:pt-10">
                          <div className="flex items-center justify-start space-x-4 mb-4 sm:mb-6">
                            <div className=" flex justify-center align-middle">
                              {/* images div */}
                              <div
                                className="relative  flex justify-center align-middle items-center "
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                              >
                                {formData?.doc ? (
                                  <div>
                                    {/* <img
                                      src={`data:image/jpeg;base64,${formData.doc}`}
                                      alt="Profile Picture"
                                      onClick={() => setIsModalOpen(true)}
                                      className={`sm:w-24  cursor-pointer sm:h-24 w-14 h-14 ring-2 ring-customgreen rounded-full`}
                                    /> */}

                                    <img
                                      src={
                                        previewImage && isProfilePicUpdated
                                          ? previewImage
                                          : formData?.doc
                                            ? `data:image/jpeg;base64,${formData.doc}`
                                            : `data:image/svg+xml;base64,${btoa(`
          <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="50.000000pt"
          height="40.000000pt"
          viewBox="0 0 290.000000 350.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
            fill="#057A55"
            stroke="none"
          >
            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />
            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />
          </g>
        </svg>`)}`
                                      }
                                      onClick={() => setIsModalOpen(true)}
                                      className="sm:w-24  cursor-pointer sm:h-24 w-14 h-14 ring-2 ring-customgreen rounded-full"
                                    />

                                    {/* {isHovered &&  <div onClick={() => setIsModalOpen(true)}
      className='cursor-pointer absolute rounded-full flex justify-end'>
      <img className='w-10 h-10 bg-cover' src='public/assets/camera.png' />
    </div>} */}

                                    <div className="items-center">
                                      <input
                                        ref={fileInputRef}
                                        type="file"
                                        id="filee"
                                        style={{ display: 'none' }}
                                        className="text-white"
                                        name="doc"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={handleProfileChange}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => setIsModalOpen(true)}
                                    className="w-24 cursor-pointer h-24 mb-3 flex items-center justify-center rounded-full border-2 border-customgreen"
                                  >
                                    <svg
                                      version="1.0"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="50.000000pt"
                                      height="50.000000pt"
                                      viewBox="0 0 290.000000 350.000000"
                                      preserveAspectRatio="xMidYMid meet"
                                    >
                                      <g
                                        transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                                        fill="#057A55"
                                        stroke="none"
                                      >
                                        <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />
                                        <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />
                                      </g>
                                    </svg>
                                    <div className="items-center">
                                      <input
                                        type="file"
                                        id="filee"
                                        style={{ display: 'none' }}
                                        className="text-white"
                                        name="doc"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={handleProfileChange}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                              {/* user name and copy profile link div */}
                              <div className=" mx-3 items-center flex">
                                <h1 className="sm:text-xl font-semibold text-customgreen">{formData.userName}</h1>
                                {/* {t('Copy Profile Link')} */}
                                <button
                                  className="group text-white mx-3 hover:bg-hovergreen border-1 border-customgreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-2 py-1 text-center"
                                  onClick={() => handleCopy(id)}
                                >
                                  <svg
                                    className="w-6 h-6 text-customgreen group-hover:text-white dark:text-customgreen"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke="currentColor"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            {/* modal code start */}

                            {isModalOpen && (
                              <>
                                <div className="mr-10">
                                  <div className="fixed inset-0  flex items-center justify-center z-50 file: bg-black bg-opacity-50">
                                    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                                      <div className="flex justify-between mb-4">
                                        <button className=" text-gray-600 hover:text-gray-800"></button>
                                        <button onClick={closeModal} className=" text-gray-600 hover:text-gray-800">
                                          <CloseIcon />
                                        </button>
                                      </div>
                                      <h2 className="text-xl mb-4 text-center text-customgreen font-semibold">
                                        {t('Upload New Profile')}
                                      </h2>

                                      <div className="my-4 flex flex-col items-center rounded-lg justify-center w-full h-36 overflow-hidden">
                                        {/* <h3 className="text-lg text-customgreen">Preview:</h3> */}
                                        <img
                                          src={
                                            previewImage && previewImage !== ''
                                              ? previewImage
                                              : formData?.doc
                                                ? `data:image/jpeg;base64,${formData.doc}`
                                                : `data:image/svg+xml;base64,${btoa(`
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="50.000000pt"
          height="40.000000pt"
          viewBox="0 0 290.000000 350.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
            fill="#057A55"
            stroke="none"
          >
            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />
            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />
          </g>
        </svg>
      `)}`
                                          }
                                          className="h-32 object-cover  w-36 shadow-md ring-2 ring-customgreen rounded-full"
                                        />
                                      </div>
                                      <label
                                        className="flex flex-col items-center justify-center h-32 border-2 border-dashed border-customgreen rounded-lg cursor-pointer hover:border-customgreen transition duration-200"
                                        // onClick={() => document.getElementById('filee').click()}
                                        onClick={handleImageUpload}
                                      >
                                        <img src="/assets/uploadimage.png" alt="Upload Icon" className="h-12 mb-2" />
                                        <span className="text-gray-500">{t('Upload Profile')} </span>
                                      </label>

                                      <div className="flex justify-center  mt-4 space-x-2">
                                        <button
                                          onClick={handleSave}
                                          className="px-3 py-2 mx-2 text-white w-32 bg-customgreen rounded-full hover:bg-hovergreen transition duration-200"
                                          aria-label="Save Image"
                                        >
                                          {t('Save Image')}
                                        </button>
                                        <button
                                          onClick={closeModal}
                                          className="px-3 py-2 bg-green-50 border-2  w-32 text-gray-700 border-customgreen  rounded-full hover:bg-white transition duration-200"
                                          aria-label="Cancel"
                                        >
                                          {t('Cancel')}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* modal code end */}
                          </div>
                        </div>

                        <div className=" flex flex-col lg:flex-row">
                          <div className="lg:hidden my-3   text-lg mt-1 bg-white lg:px-12 font-medium text-center text-gray-500 border-b rounded-lg border-gray-50 dark:text-gray-400">
                            {/* new codde */}
                            <div className="flex justify-center">
                              <Stack
                                direction="row"
                                sx={{
                                  overflowY: 'auto',
                                  height: 'auto',
                                  flexDirection: 'row', // Always set to row
                                  whiteSpace: 'nowrap', // Prevent text from wrapping to the next line
                                  '&::-webkit-scrollbar': {
                                    width: '8px', // Adjust width for WebKit browsers
                                  },
                                  '&::-webkit-scrollbar-track': {
                                    background: 'transparent', // Background of the track set to transparent
                                  },
                                  '&::-webkit-scrollbar-thumb': {
                                    background: '#047857', // Color of the scrollbar thumb set to customgreen
                                    borderRadius: '10px', // Rounded corners for the thumb
                                  },
                                  scrollbarWidth: 'thin', // For Firefox
                                  scrollbarColor: '#047857 transparent', // For Firefox: thumb color and track color
                                }}
                              >
                                {buttonArray.map((category) => (
                                  <button
                                    key={category.name}
                                    onClick={() => handleButtonClick(category.name, category.id)}
                                    className={`inline-block my-2 mx-1 px-2 active bg-gray-100 hover:text-gray-600 border-gray-300 transition-colors text-customgreen hover:border-customgreen rounded-t-lg py-1 sm:px-4 max-[638px]:text-sm text-lg max-[638px]:px-2 font-medium text-center ${
                                      selectedButton === category.name
                                        ? 'bg-gray-200 border-green-700 border-t-8'
                                        : 'bg-gray-100 text-gray-800'
                                    }`}
                                  >
                                    {t(`${category.name}`)}
                                  </button>
                                ))}
                              </Stack>
                            </div>
                          </div>

                          <div
                            className={`hidden w-full lg:block lg:w-2/5 xl:w-1/5 ${isActive ? 'border-l-slate-50 border-l-2 sm:pl-4' : 'border-r-slate-50 border-r-2 sm:pr-4 '} overflow-x-auto mb-1 md:mb-6`}
                            style={{ scrollbarWidth: 'thin' }}
                          >
                            <div className="flex flex-row justify-center  lg:flex-col flex-wrap my-3 lg:space-x-0 scrollbar-custom">
                              {buttonArray.map((item) => {
                                const { name, id } = item;
                                return (
                                  <button
                                    key={id}
                                    className={`flex-shrink-0 w-28 px-2 mx-2 lg:w-full  ${isActive ? 'sm:text-right' : 'sm:text-left'} text-xss lg:text-base font-bold py-2 sm:px-4 sm:mb-2 rounded-lg ${selectedButton === name ? 'bg-green-100' : 'bg-white'}`}
                                    onClick={() => handleButtonClick(name, id)}
                                  >
                                    {`${t(name)}`}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                          <div className=" w-full flex mb-1 md:mb-6 flex-col">
                            <div className={`flex  w-full ${isActive ? 'sm:pr-4' : 'sm:pl-4'}`}>
                              {/* <div className='lg:w-2/5 xl:w-1/5 w-0'> */}
                              {/* empty div for heading and button setting */}
                              {/* </div> */}

                              {/* heading and button */}
                              <div className={`w-full flex  justify-between`}>
                                <h2
                                  className={`md:text-2xl font-semibold  sm:text-center text-customgreen mb-4 sm:mb-6`}
                                >
                                  {tab === 1
                                    ? t('Edit Profile')
                                    : tab === 2
                                      ? t('Security')
                                      : tab === 3
                                        ? t('Choose Plan')
                                        : tab === 4
                                          ? t('Change Password')
                                          : tab === 5
                                            ? t('Login History')
                                            : ''}
                                </h2>
                                <button
                                  className={`${tab == 5 ? 'hidden' : 'w-20 md:w-32 py-2 rounded-lg bg-customgreen flex items-center justify-center text-white h-6 text-xs sm:text-base px-4 sm:px-3 sm:h-11 '} `}
                                  onClick={() => handleEditClick(tab)}
                                >
                                  {t('Edit')}
                                </button>
                              </div>
                            </div>
                            {/* Edit Profile Section */}
                            {(tab == 1 && (
                              <div className={`w-full  ${isActive ? 'sm:pr-4' : 'sm:pl-4'}`}>
                                <form onSubmit={handleSaveClick}>
                                  <div className="flex w-full  flex-col ">
                                    <div className="flex  w-full flex-wrap">
                                      <div className="flex-col w-full flex md:flex-row justify-start gap-3 sm:gap-6 md:space-x-2">
                                        <div className="w-full ">
                                          <label className="block  text-customgreen">
                                            {t('Full Name')}
                                            <span className="errmsg">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            required
                                            className="w-full mt-1  p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                            placeholder={t('First Name')}
                                            name="fullName"
                                            value={formData.fullName}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                          />
                                        </div>
                                        <div className="w-full ">
                                          <label className="block  text-customgreen">
                                            {t('User Name')}
                                            <span className="errmsg">*</span>
                                          </label>
                                          <input
                                            required
                                            type="text"
                                            className="w-full mt-1  p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                            placeholder={t('User Name')}
                                            name="userName"
                                            value={formData.userName}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                          />
                                        </div>
                                      </div>
                                      {/* <div className='flex-col w-full  flex md:flex-row justify-start  lg:gap-3 sm:gap-6 md:space-x-2'>
                                    <div className='w-full  form-group py-2'>
                                      <label className='block text-xss lg:text-base bold text-customgreen'>{t('Country')}</label>
                                      <select
                                        className='w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen'
                                        name='countryID'
                                        onChange={handleChange}
                                        disabled={!isEditing}
                                      >
                                        <option value={formData.countryID}>{formData.countryName ?? "--SELECT--"}</option>
                                        {countryAPIData && countryAPIData.length > 0 ? (
                                          countryAPIData.map((item) => (
                                            <option key={item.countryID} value={item.countryID}>
                                              {item.countryName}
                                            </option>
                                          ))
                                        ) : (
                                          <option>{t('No country found')}</option>
                                        )}
                                      </select>
                                    </div>

                                    <div className='w-full '>
                                      {showhide == 208 && (

                                        <div className="form-group py-2">
                                          <label className='block bold text-customgreen text-xss lg:text-base'>
                                            {t('Emirates')}
                                            <span className="errmsg">*</span>
                                          </label>
                                          <select
                                            className='w-full mt-1 text-xss lg:text-base p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen'
                                            name='emiratesID'
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                          >
                                            <option value={formData.emiratesID}>
                                              {formData.emiratesName ?? "--SELECT--"}
                                            </option>
                                            {emiratesAPIData && emiratesAPIData.length > 0 ? (
                                              emiratesAPIData.map((item) => (
                                                <option key={item.emiratesID} value={item.emiratesID}>
                                                  {item.en_US}
                                                </option>
                                              ))
                                            ) : (
                                              <option>{t('No Emirates found')}</option>
                                            )}
                                          </select>
                                        </div>

                                      )}

                                    </div>
                                  </div> */}

                                      <div className="flex-col w-full flex md:flex-row justify-start lg:gap-3 sm:gap-6 md:space-x-2">
                                        <div className="w-full form-group py-2">
                                          <label className="block  text-customgreen">
                                            {t('Country')}
                                            <span className="errmsg">*</span>
                                          </label>
                                          <select
                                            // required
                                            className="w-full cursor-not-allowed mt-1 p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                            name="countryID"
                                            onChange={handleChange}
                                            disabled="true"
                                            value={formData?.countryID} // Bind the selected value to the state
                                          >
                                            <option value={''}>--{t('SELECT')}--</option> {/* Default select option */}
                                            {countryAPIData && countryAPIData?.length > 0 ? (
                                              countryAPIData?.map((item) => (
                                                <option key={item?.countryID} value={item?.countryID}>
                                                  {isActive ? item?.ar_SA : item.countryName}
                                                </option>
                                              ))
                                            ) : (
                                              <option>{t('No country found')}</option>
                                            )}
                                          </select>
                                        </div>

                                        <div className="w-full">
                                          {showhide == 208 && (
                                            <div className="form-group py-2">
                                              <label className="block  text-customgreen">
                                                {t('Emirates')}
                                                <span className="errmsg">*</span>
                                              </label>
                                              <select
                                                className="w-full mt-1  p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                                name="emiratesID"
                                                onChange={handleChange}
                                                disabled={!isEditing}
                                                value={formData.emiratesID} // Bind the selected value to the state
                                              >
                                                <option value={''}>--{t('SELECT')}--</option>{' '}
                                                {/* Default select option */}
                                                {emiratesAPIData && emiratesAPIData.length > 0 ? (
                                                  emiratesAPIData.map((item) => (
                                                    <option key={item.emiratesID} value={item.emiratesID}>
                                                      {t(isActive ? item?.ar_SA : item?.en_US)}
                                                    </option>
                                                  ))
                                                ) : (
                                                  <option>{t('No Emirates found')}</option>
                                                )}
                                              </select>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-col w-full sm:py-2 flex md:flex-row justify-start lg:gap-3 sm:gap-6 md:space-x-2">
                                      <button
                                        onClick={handleSave}
                                        className={`w-20 md:w-32 ${isEditing ? 'bg-customgreen ' : 'bg-green-200'} text-xss lg:text-base text-white py-2 rounded-lg`}
                                        disabled={!isEditing}
                                      >
                                        {t('Update')}
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            )) ||
                              (tab == 2 && (
                                <div className={`w-full  ${isActive ? 'sm:pr-4' : 'sm:pl-4'}`}>
                                  <div className="grid w-full  grid-cols-1 md:grid-cols-1 gap-3 sm:gap-6">
                                    <div className="flex-col w-full flex md:flex-row justify-start gap-3 sm:gap-6 md:space-x-2">
                                      <div className="w-full ">
                                        <UserPersonalnfo
                                          tab={tab}
                                          isSecurityEditing={isSecurityEditing}
                                          setIsSecurityEditing={setIsSecurityEditing}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )) ||
                              (tab == 4 && (
                                <div className={`w-full  ${isActive ? 'sm:pr-4' : 'sm:pl-4'}`}>
                                  <form>
                                    <div className="flex w-full  flex-col  gap-3 ">
                                      <div className="flex w-full  flex-wrap">
                                        <div className="flex-col w-full  flex md:flex-row justify-start gap-3 sm:gap-6 md:space-x-2">
                                          <div className="w-full ">
                                            <label className="block bold  text-customgreen">
                                              {t('Current Password')}
                                              <span className="errmsg">*</span>
                                            </label>
                                            <div className="relative">
                                              <input
                                                required
                                                className="w-full mt-1  p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                                type={showCurrentPassword ? 'text' : 'password'}
                                                name="oldPassword"
                                                placeholder={t('Current Password')}
                                                minLength="8"
                                                value={passwordData.oldPassword}
                                                maxLength="50"
                                                onChange={handlePasswordChange}
                                                disabled={!isPasswordEditing}
                                              />
                                              <button
                                                type="button"
                                                className={`absolute inset-y-0 ${isActive ? 'left-0 pl-3' : 'right-0 pr-3'} flex items-center text-sm leading-5`}
                                                onClick={toggleCurrentPasswordVisibility}
                                              >
                                                {isPasswordEditing &&
                                                  (showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />)}
                                                {/* {showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />} */}
                                              </button>
                                            </div>
                                          </div>
                                          <div className="w-full ">
                                            <label className="block bold text-customgreen">
                                              {t('New Password')}
                                              <span className="errmsg">*</span>
                                            </label>
                                            <div className="relative">
                                              <input
                                                required
                                                type={showNewPassword ? 'text' : 'password'}
                                                placeholder={t('New Password')}
                                                name="newPassword"
                                                className="w-full mt-1 p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                                minLength="8"
                                                maxLength="50"
                                                value={passwordData.newPassword}
                                                onChange={handlePasswordChange}
                                                disabled={!isPasswordEditing}
                                              />
                                              <button
                                                type="button"
                                                className={`absolute inset-y-0 ${isActive ? 'left-0 pl-3' : 'right-0 pr-3'}  flex items-center text-sm leading-5`}
                                                onClick={toggleNewPasswordVisibility}
                                              >
                                                {isPasswordEditing &&
                                                  (showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />)}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex-col w-full flex  mt-3 md:flex-row justify-start gap-3  sm:gap-6 md:space-x-2 ">
                                          <div className="w-full ">
                                            <label className="block bold  text-customgreen">
                                              {t('Confirm Password')}
                                              <span className="errmsg">*</span>
                                            </label>
                                            <div className="relative">
                                              <input
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                // type="password"
                                                required
                                                name="confirmPassword"
                                                placeholder={t('Confirm Password')}
                                                className="w-full mt-1  p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
                                                minLength="8"
                                                maxLength="50"
                                                value={passwordData.confirmPassword}
                                                onChange={handlePasswordChange}
                                                disabled={!isPasswordEditing}
                                              />
                                              <button
                                                type="button"
                                                className={`absolute inset-y-0 ${isActive ? 'left-0 pl-3' : 'right-0 pr-3'}  flex items-center text-sm leading-5`}
                                                onClick={toggleConfirmPasswordVisibility}
                                              >
                                                {isPasswordEditing &&
                                                  (showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />)}
                                              </button>
                                            </div>
                                          </div>
                                          <div className="w-full "></div>
                                        </div>
                                        <div className="flex-col w-full md:mt-3 flex md:flex-row justify-start gap-3 sm:gap-6 md:space-x-2">
                                          <button
                                            className={`w-20 md:w-32 ${isPasswordEditing ? 'bg-customgreen' : ' bg-green-200'} text-xss lg:text-base text-white py-2 rounded-lg`}
                                            onClick={changePassword}
                                            disabled={!isPasswordEditing}
                                          >
                                            {t('Update')}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              )) ||
                              (tab == 5 && (
                                <div className={`w-full  ${isActive ? 'sm:pr-4' : 'sm:pl-4'}`}>
                                  <div className="grid w-full  grid-cols-1 ">
                                    <div className="flex-col w-full flex md:flex-row justify-start gap-3 ">
                                      <div className="w-full ">
                                        <UserLogs />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="flex w-full bg-white  gap-2  min-h-80 ">
                  <UserDashboardCard />
                </div>
              </div>
            )}
          </div>{' '}
        </>
      )}
    </>
  );
};

export default UserPortalHomePage;
